// Vendor Libs
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {get, isEmpty} from 'lodash';

// Redux Actions
import {
    flaggedMetadataAddIssue,
    flaggedMetadataCompleteFlagging,
    flaggedMetadataDeleteIssue,
    flaggedMetadataReset,
    flaggedMetadataSaveComments,
    flaggedMetadataSetActive,
} from '../actions/flagged-metadata-actions';
import {setFieldValue, setFieldValues} from '../actions/form-data-actions';

function FlaggedMetadata({
    children,
    flaggedMetadata = {},
    flaggedMetadataAddIssue,
    flaggedMetadataCompleteFlagging,
    flaggedMetadataDeleteIssue,
    flaggedMetadataIssues,
    flaggedMetadataReset,
    flaggedMetadataSaveComments,
    flaggedMetadataSetActive,
    massActionTargets,
}) {
    const setIssueFormValue = (fieldName, value) => setFieldValue('flagMetadataIssue', fieldName, value);

    const setIssueFormValues = (values) => setFieldValues('flagMetadataIssue', values);

    const getChildrenProps = () => {
        const {echostarId, error, fetching, roviProgramId, servicesDataKey, sourceId, tmsId} = flaggedMetadata;

        return {
            echostarId,
            error,
            fetching,
            flaggedMetadataAddIssue,
            flaggedMetadataCompleteFlagging,
            flaggedMetadataDeleteIssue,
            flaggedMetadataIssues,
            flaggedMetadataReset,
            flaggedMetadataSaveComments,
            flaggedMetadataSetActive,
            inSpecialMode: !isEmpty(massActionTargets),
            roviProgramId,
            servicesDataKey,
            setIssueFormValue,
            setIssueFormValues,
            sourceId,
            tmsId,
        };
    };

    return children ? children(getChildrenProps()) : null;
}

FlaggedMetadata.propTypes = {
    children: PropTypes.func,
    flaggedMetadata: PropTypes.object,
    flaggedMetadataAddIssue: PropTypes.func,
    flaggedMetadataCompleteFlagging: PropTypes.func,
    flaggedMetadataDeleteIssue: PropTypes.func,
    flaggedMetadataIssues: PropTypes.array,
    flaggedMetadataReset: PropTypes.func,
    flaggedMetadataSaveComments: PropTypes.func,
    flaggedMetadataSetActive: PropTypes.func,
    massActionTargets: PropTypes.array,
};

const mapStateToProps = ({formData, flaggedMetadata, massActionData}) => ({
    flaggedMetadata,
    flaggedMetadataIssues: get(formData, 'flagMetadataIssues.values.issues', []),
    massActionTargets: get(massActionData, 'targets', []),
});

const mapDispatchToProps = {
    flaggedMetadataAddIssue,
    flaggedMetadataCompleteFlagging,
    flaggedMetadataDeleteIssue,
    flaggedMetadataReset,
    flaggedMetadataSaveComments,
    flaggedMetadataSetActive,
    setFieldValue,
    setFieldValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(FlaggedMetadata);
